import styled from 'styled-components';

export const MermaidDiv = styled.div`
  text-align: left;
  white-space: pre;
`;
